export default __webpack_public_path__ + "static/media/typeORM.f3094d8a.png";